import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

const formatLabel = (str) =>
  str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

const BooleanField = ({ attr, isEditing, onChange, onCheckboxChange }) => {
  const isTrue = attr.value === true || attr.value === 'true';

  return (
    <div className="space-y-2">
      <div className="text-sm text-gray-500">
        <strong>{formatLabel(attr.attribute_name)}</strong>
        <FontAwesomeIcon
          icon={attr.approved ? faCircleCheck : faCircle}
          className={attr.approved ? 'ml-2 text-green-400' : 'ml-2 text-gray-400'}
        />
      </div>
      {isEditing ? (
        <>
          <label className="inline-flex items-center space-x-2">
            <input
              type="checkbox"
              checked={isTrue}
              onChange={(e) => onChange(attr.id, 'value', e.target.checked)}
              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
            />
            <span className="text-sm text-gray-800">{isTrue ? 'Yes' : 'No'}</span>
          </label>
          <label className="text-xs text-gray-600 flex items-center space-x-1 mt-1">
            <input
              type="checkbox"
              checked={attr.approved || false}
              onChange={(e) => onCheckboxChange(attr.id, 'approved', e.target.checked)}
              className="rounded border-gray-300"
            />
            <span>Approved</span>
          </label>
        </>
      ) : (
        <div
          className={`border rounded-md px-3 py-1.5 text-sm ${
            isTrue
              ? 'bg-green-50 border-green-300 text-green-700'
              : 'bg-red-50 border-red-300 text-red-700'
          }`}
        >
          {isTrue ? 'Yes' : 'No'}
        </div>
      )}
    </div>
  );
};

export default BooleanField;